import { Box, Link } from '@mui/material';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
import Main from '../home/main';
import Header from './header';

type Props = {
  children: React.ReactNode;
};
export default function GuestLayout({ children }: Props) {
  return (
    <>
      <Header />
      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          width: 1,
        }}
      >
        <Main>{children}</Main>
      </Box>
      <Link
        component={RouterLink}
        href={paths.home.trang_chu}
        sx={{
          color: 'text.secondary',
          position: 'fixed',
          bottom: 8,
          left: 8,
          typography: 'caption',
          fontWeight: 500,
        }}
      >
        Dành cho quản trị viên
      </Link>
    </>
  );
}
